<script setup>
import { computed, onMounted, ref, watch } from 'vue'
import Pie from '@/components/echarts/Pie.vue'
import TotalStatisticsBar from '@/views/admin/components/TotalStatisticsBar.vue'

const props = defineProps({
  dataList: {
    type: Object,
    default: () => [],
  },
  chartType: Number,
})

const pieRef = ref()

// 计算已填报、未填报、总人数、完成率
const cmpData = computed(() => {
  const totalPerson = props.dataList?.[0]?.totalPerson || 0
  const completePerson = props.dataList?.[0]?.completePerson || 0
  const unCompletePerson = totalPerson - completePerson
  const completePercent =
    totalPerson === 0 ? 0 : ((completePerson / totalPerson) * 100).toFixed(0)

  return {
    totalPerson,
    completePerson,
    unCompletePerson,
    completePercent: completePercent === 'NaN' ? 0 : completePercent,
  }
})

const generatePieOption = () => {
  return {
    series: [
      {
        // 创建一个完整的白色环形图
        type: 'pie',
        radius: ['42%', '54%'],

        data: [{ value: 1, name: '', itemStyle: { color: 'white' } }],
        itemStyle: {
          normal: {
            color: function (params) {
              // 自定义颜色
              var colorList = ['#50A2F2', '#01D2A9']
              return colorList[params.dataIndex]
            },
            shadowColor: 'rgba(0, 0, 0, 0.2)',
            shadowBlur: 20,
            shadowOffsetX: 0,
            shadowOffsetY: 0,
          },
        },
        labelLine: {
          show: false,
        },
      },
      {
        name: '环形图示例',
        type: 'pie',
        radius: ['45%', '50%'],
        center: ['50%', '50%'], // 将环形图放在容器的中间
        avoidLabelOverlap: false,
        itemStyle: {
          normal: {
            color: function (params) {
              // 自定义颜色
              var colorList = ['#728AFB', '#01D2A9']
              return colorList[params.dataIndex]
            },
          },
        },
        label: {
          show: false,
          position: 'center',
        },
        emphasis: {
          label: {
            show: true,
            fontSize: '30',
            fontWeight: 'bold',
          },
        },
        labelLine: {
          show: false,
        },
        data: [
          { value: cmpData.value.completePerson, name: '已填报' },
          {
            value: cmpData.value.unCompletePerson,
            name: '未填报',
          },
        ],
      },
    ],
    graphic: {
      elements: [
        {
          type: 'text',
          left: 'center',
          top: '40%',
          style: {
            text: `${cmpData.value.completePercent}%`,
            fill: '#333',
            fontSize: 26,
            fontWeight: 'bold',
          },
        },
        {
          type: 'text',
          left: 'center',
          top: '54%',
          style: {
            text: '已填报',
            fill: '#999999',
            fontSize: 14,
          },
        },
      ],
    },
  }
}

watch(
  () => props.dataList,
  (n) => {
    pieRef.value?.renderChart(generatePieOption())
  }
)
</script>
<template>
  <TotalStatisticsBar v-if="chartType === 1" :data="dataList" />
  <div v-else class="total-wrap">
    <Pie ref="pieRef" class="total-pie" :option="generatePieOption()" />
    <ul class="text-list">
      <li class="text-item">
        <img class="text-img" src="@/assets/img/admin/total-person.png" />
        总人数
        <strong>{{ cmpData.totalPerson }}人</strong>
      </li>
      <li class="text-item">
        <img class="text-img" src="@/assets/img/admin/uncomplete-person.png" />
        已填写 <strong>{{ cmpData.completePerson }}人</strong>
      </li>
      <li class="text-item">
        <img class="text-img" src="@/assets/img/admin/complete-person.png" />
        未填写 <strong>{{ cmpData.unCompletePerson }}人</strong>
      </li>
    </ul>
  </div>
</template>
<style lang="scss" scoped>
.total-wrap {
  position: relative;
  display: flex;
  /* margin-bottom: 38px; */

  &::after {
    position: absolute;
    content: '';
    left: -26px;
    right: -26px;
    bottom: 50px;
    height: 6px;
    background: #eaeaea;
    opacity: 0.5;
  }
}
.total-pie {
  position: relative;
  top: -20px;
  left: -40px;
  width: 480px;
  height: 480px;
}

.text-list {
  position: relative;
  left: -60px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  .text-item {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    font-size: 28px;
    color: #333333;

    .text-img {
      box-sizing: border-box;
      margin-right: 20px;
      width: 65px;
      height: 65px;
    }

    strong {
      font-size: 30px;
    }
  }
}
</style>
